<template>
	<az-container class="listagem ml-0 mb-1">
		<v-row class="mt-2">
			<v-col>
				<h1 class="title font-weight-bold color-titulo">Itens</h1>
			</v-col>
			<v-col class="d-flex justify-end">
				<az-search
					:filter="filtroIdAtaButtonsValues"
					simple-search-placeholder="Busque por: descrição do item"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</v-col>
		</v-row>

		<div class="">
			<v-row>
				<v-col cols="12" sm="12" class="">
					<listagem-itens-ata-view
						:itens="datasource"
						:total-paginas="totalPaginas"
						:total-itens="totalItens"
						:paginacao="paginacao"
						@paginar="setPaginacao"
						@resetar-page="resetarPaginaItemListagem()"
					></listagem-itens-ata-view>
				</v-col>
			</v-row>
		</div>
	</az-container>
</template>
<script>
import { mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'
import { actionTypes } from '@/core/constants'
import ListagemItensAtaView from '@/views/pages/ata/pesquisa/acessar/itens/listagem/ListagemItensAtaView.vue'
import rpCurrencyFilter from '@/views/filters/rp-currency-filter'

export default {
	name: 'pesquisa-itens-view',
	components: { ListagemItensAtaView },
	data() {
		return {
			paginacao: this.$store.state.itens.paginacao,
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.itens.filtro,
		}),
		filtroIdAtaButtonsValues() {
			const { idAta, ...resto } = this.filtro
			return resto
		},
	},
	async mounted() {
		await this.carregarItens()
	},
	methods: {
		async buscar(searchText) {
			if (searchText) {
				this.filtro.descricao.value = searchText
			}

			this.resetarPaginaItemListagem()
			await this.carregarItens()
		},
		async carregarItens() {
			this.filtro.idAta = { value: this.$route.params.id }
			const retorno = await this.$store.dispatch(actionTypes.ITENS.BUSCAR_POR_FILTRO)
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.datasource = retorno.itens.map((item) => {
				item.valorUnitario = rpCurrencyFilter(
					item.valorUnitario,
					'R$ ',
					this.$store.state.casasDecimais.numeroCasasDecimaisValores,
				)
				item.estoqueAtual = rpCurrencyFilter(
					item.estoqueAtual,
					'',
					this.$store.state.casasDecimais.numeroCasasDecimaisQtde,
				)
				return item
			})
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ITENS.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarItens()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			await this.carregarItens()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.ITENS.RESETAR_PAGINA_LISTAGEM)
		},
	},
}
</script>
<style scoped lang="stylus"></style>
